export const JobTeaser = () => {
    const refJobs = document.querySelector('#jobs');
    const refTeaser = document.querySelector('.jobTeaser');

    //console.log('Job teaser activated');

    const getLang = () => {

        let lang = document.documentElement.lang;
        if (lang === 'de-CH') {
            return 'DE';
        } else if (lang === 'fr-CH') {
            return 'FR';
        } else if (lang === 'en') {
            return 'EN';
        } else {
            return 'DE';
        }
    }

    const [apiUrl, apiToken, apiLang] = ['https://odm.ostendis.com/ojp/', process.env.OSTENDIS_TOKEN, getLang()];

    const getHtmlNode = (html) => {
        const templ = document.createElement('template');
        templ.innerHTML = html.trim();
        return templ.content.firstChild.cloneNode(true);
    }

    const getNoJobMarkup = (message) => {
        return `<article>
            <span>${message}</span>
            </article>`
    }

    const getJobMarkup = (job, translations, lang) => {
        let workload = '';
        let location = `<li class="jobCard__infos-location">${job.countrycode} - ${job.city}</li>`;
        if (job.workload_min == job.workload_max) {
            workload += `<li class="jobCard__infos-workload">${job.workload_min}%</li>`;
        } else {
            workload += `<li class="jobCard__infos-workload">${job.workload_min} - ${job.workload_max}%</li>`;
        }
        return `<article class="jobCard">
            <div class="jobCard__title">${job.title}</div>
            <ul class="jobCard__infos">` + workload + location + `</ul>
            <ul class="jobCard__actions">
                <li><a target="_blank" class="action action-secondary" href="${job.detail}" title="${translations[lang]['detail']}" aria-label="${translations[lang]['detail']}">
                <span class="action__text">${translations[lang]['detail']}</span>
                </a>
                
                <li>
                <a target="_blank" class="action action-primary" href="${job.action}" title="Jetzt bewerben" aria-label="${translations[lang]['application']}">
                <span class="action__text">${translations[lang]['application']}</span>
                </a>
                
            </ul>
        </article>`;
    }

    const getRequest = (url, cb, onError = () => {
    }) => {
        fetch(url)
            .then(res => res.json())
            .then(obj => cb(obj))
            .catch(e => {

                onError(e);
            });
    }

    const fetchVersion = (cb, onError) => getRequest(`${apiUrl}assets/version/${apiToken}`, cb, onError);
    const fetchJobs = ({version}) => getRequest(`${apiUrl}data/${version}/jobs/${apiToken}/${apiLang}`, appendJobs, handleError);

    const appendJobs = ({jobs, error}) => {
        if(jobs.length === 0) {
            refJobs.appendChild(getHtmlNode(getNoJobMarkup(error.message)));
            refTeaser.classList.add('jobTeaser--loaded');
            return
        }

        let translations = {
            de: {
                detail: 'Detailinfo',
                application: 'Jetzt bewerben'
            },
            fr: {
                detail: 'Détails',
                application: 'Postuler maintenant'
            },
            en: {
                detail: 'More details',
                application: 'Apply now'
            }
        };
        jobs.map(job => getJobMarkup(job, translations, getLang().toLowerCase()))
            .map(htmlStr => getHtmlNode(htmlStr))
            .forEach(node => refJobs.appendChild(node));
        refTeaser.classList.add('jobTeaser--loaded');
    }

    const handleError = (error) => {
        refTeaser.classList.add('jobTeaser--error');
    }

    const init = () => {
        fetchVersion(fetchJobs, handleError);
    }

    init();
}
